"use client";

import { useEffect } from "react";
import { useRefreshCart } from "@/hooks/use-refresh-cart";
import { useCartStore, selectEntries } from "@/lib/cart/cart-store";

export default function CartInitializer() {
  const refreshCart = useRefreshCart();
  const entries = useCartStore(selectEntries);

  useEffect(() => {
    refreshCart();
  }, [refreshCart]);

  // Sync cart product IDs to a cookie so server components can read them
  useEffect(() => {
    const ids = entries.map((e) => e.productId).join(",");
    document.cookie = `cart_item_ids=${encodeURIComponent(ids)};path=/;max-age=${60 * 60 * 24 * 365};samesite=lax`;
  }, [entries]);

  return null;
}
